import React from 'react'
import styled from 'styled-components/macro'

interface IProps {
  imageName: string
  className?: string
  fallbackColor?: string
  fixed?: boolean
  size?: 'cover' | 'contain' | 'inherit'
  children?: any
  component?: any
}

export const BackgroundThemed: React.FC<IProps> = ({
  imageName,
  fallbackColor = '#5b453c',
  fixed = false,
  size = 'inherit',
  children,
  component = 'div',
  ...otherProps
}) =>
  React.createElement(
    styled(component)`
      background-image: ${props => `url('${props.theme[imageName]}')`};
      background-attachment: ${props => (fixed ? 'fixed' : 'inherit')};
      background-repeat: no-repeat;
      background-position: left top;
      background-size: ${props => size};
    `,
    otherProps,
    children,
  )

export default BackgroundThemed
